import React from 'react'

const ShippingPolicy = () => {
  return (
    <div className='container py-4'>
      <div className='bg-light p-4 rounded shadow-sm'>
        <h1 className='mb-4'>Shipping Policy</h1>
        <p>
          We currently deliver our products/services across India. Shipping
          timelines and charges may vary depending on the product and location.
        </p>

        <h2 className='mt-4'>Shipping Time</h2>
        <p>
          Orders are typically processed within 1-3 business days and delivered
          within 5-10 business days.
        </p>

        <h2 className='mt-4'>Delivery Partners</h2>
        <p>
          We use trusted logistics partners like Delhivery, BlueDart, and others
          to ensure timely delivery.
        </p>

        <h2 className='mt-4'>Shipping Charges</h2>
        <p>
          Shipping is free for prepaid orders above ₹499. Below that, a flat
          rate of ₹50 will be applied.
        </p>

        <p className='mt-4'>
          For any issues related to shipping, please contact us at
          info@teslabird.com .
        </p>
      </div>
    </div>
  )
}

export default ShippingPolicy
